
<div class="panel-admin">
    <div class="container-panel">
        <app-menu-panel [itemActive]="tabActive" [hideDesktopNavigation]="true" (changeTab)="changeTab($event)"></app-menu-panel>
        <div class="panel-dashboard container">
            <div class="panel-layout row">
                <div class="col-lg-3 col-xl-2 d-none d-lg-block side-menu-column">
                    <app-side-menu-panel [itemActive]="tabActive" (changeTab)="changeTab($event)"></app-side-menu-panel>
                </div>
                <div class="col-12 col-lg-9 col-xl-10">
                    <div class="submenu-router" *ngIf="activeSubmenu && !routerCreateEvent">
                        <app-submenu-panel></app-submenu-panel>
                        <mat-divider></mat-divider>
                    </div>
                    <div class="submenu-router" *ngIf="isVenuesRoute && !routerVenues">
                        <h1 class="m-0 title-submenu">Espacios</h1>
                        <mat-divider></mat-divider>
                    </div>
                    <div class="submenu-router" *ngIf="isProfileRoute">
                        <h1 class="m-0 title-submenu">Mi perfil</h1>
                        <mat-divider></mat-divider>
                    </div>
                    <div class="submenu-router" *ngIf="isHelpRoute">
                        <h1 class="m-0 title-submenu">Ayuda</h1>
                        <mat-divider></mat-divider>
                    </div>
                    <div class="submenu-router" *ngIf="isBusinessRoute">
                        <h1 class="m-0 title-submenu">Organización</h1>
                        <mat-divider></mat-divider>
                    </div>
                    <div class="submenu-router" *ngIf="isPermissionRoute">
                        <h1 class="m-0 title-submenu">Gestores</h1>
                        <mat-divider></mat-divider>
                    </div>
                    <div class="router-panel">
                        <div *ngIf="routerDetailEvent || routerVenues || routerCreateEvent; else detailEvents">
                            <app-router-events *ngIf="routerDetailEvent"></app-router-events>
                            <app-router-venue *ngIf="routerVenues"></app-router-venue>
                            <app-router-create *ngIf="routerCreateEvent"></app-router-create>
                        </div>
                        <ng-template #detailEvents>
                            <router-outlet></router-outlet>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>